import moment from "moment-timezone";
import i18n from "@/plugins/i18n";
import store from "@/plugins/store/store";
import router from "@/plugins/router";

export default {
  redirectToLogin() {
    try {
      if (router.currentRoute && router.currentRoute.name === "login") return;
      router.replace({ name: "login" }).catch(() => {
        window.location.hash = "#/login";
      });
    } catch (e) {
      window.location.hash = "#/login";
    }
  },
  async convertCsvToJson(csvFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      let lines;
      let headers;
      let jsonArray = [];

      try {
        reader.readAsText(csvFile, 'utf8');
        reader.onload = () => {
          const csv = reader.result;

          const normalizedCSV = csv.replace(/\r\n|\r|\n/g, '\n');

          lines = normalizedCSV.split('\n');

          const separator = this.detectSeparatorFromHeader(lines[0]);

          headers = lines[0].split(separator);

          for (let i = 1; i < lines.length; i++) {
            const line = lines[i].split(separator);
            let object = {};
            for (let j = 0; j < headers.length; j++) {
              object[headers[j]] = line[j];
            }

            const hasValue = !!Object.values(object).find(o => o != "" && o != undefined);

            if (hasValue) {
              jsonArray.push(object);
            }
          }

          resolve(jsonArray);
        }
      } catch (e) {
        reject(e);
      }
    })
  },
  detectSeparatorFromHeader(headerLine) {
    if (headerLine == null) {
      return ',';
    }
    const separators = [',', ';', '\t', '|'];
    return separators.find(sep => headerLine.includes(sep)) || ',';
  },
  get_dim(last_calving) {
    return last_calving ? moment(moment()).diff(last_calving, 'days') : i18n.t("general.notAvailable")
  },
  fromUtcToLocalDate(date = new Date()) {
    const tz = (store.state.user && store.state.user.timezone)
      ? store.state.user.timezone
      : moment.tz.guess(true);
    const convertedTime = moment.tz(moment.tz(date, 'UTC'), tz);
    return convertedTime
  },
  utcDate(date = new Date()) {
    return moment(date).toISOString(false).slice(0, -5);
  },
  // Get YYYY-MM-DD format regardless of timezone
  getDate(date = new Date()) {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  },
  formatPercentage(value, decimals = 1) {
    if (value == null || value == undefined || isNaN(value)) {
      return i18n.t("general.notAvailable");
    }
    return (parseFloat(value) * 100.0).toFixed(decimals) + "%";
  },
  lastHeat(alert) {
    const currentHeat = moment(alert.alert_time),
      prevHeat = moment(alert.last_heat);

    if (!prevHeat) {
      return i18n.t("dashboardView.alerts.lastHeat") + ": N/A";
    }

    const duration = moment.duration(currentHeat.diff(prevHeat))
    
    const preText = i18n.t("dashboardView.alerts.lastHeat");

    // Use asDays() to get the total duration in days instead of just the days component
    const daysAgo = Math.floor(duration.asDays())

    return preText + ": " + i18n.t("general.daysAgo").replace("*", "" + daysAgo);
  },
  downloadCsv(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      filename
    );
    document.body.appendChild(link);
    link.click();
  },
  formatRequestDate(date) {
    if (!date)
      return null;
    return moment(date).format('YYYY-MM-DDTHH:mm:ss')
  },
}


// WEBPACK FOOTER //
// ./src/services/UtilsService.js